import React from 'react'

import '../../assets/style/ui/square_winner.css'

const SquareWinner = ({ points = 50, label = 'Yelmo points' }) => {
  return (
    <div style={{ marginBottom: '8%' }} className="square-container">
      <div className="points">{points}</div>
      <div className="label">{label}</div>
      <div className="star top-left">✦</div>
      <div className="star top-right">✦</div>
      <div className="star bottom-left">✦</div>
    </div>
  )
}

export default SquareWinner
